<template>
  <div class="transactions">
    <v-row>
      <v-col>
        <breadcrumb :items="breadcrumbs" />
      </v-col>
      <v-col class="text-right">
        <v-btn
          color="primary"
          class="mb-5"
          @click="showAddPaymentDialog = true"
        >
          <v-icon
            left
            size="22"
          >
            {{ icons.mdiCash }}
          </v-icon>
          Add Payment
        </v-btn>
      </v-col>
    </v-row>
    <payments-table
      :transaction-url="transactionUrl"
      :show-add-payment-dialog="showAddPaymentDialog"
      @add-payment-dialog-closed="showAddPaymentDialog = false"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { mdiCash } from '@mdi/js'
import BreadCrumb from '@/components/partials/BreadCrumb.vue'
import ManagedClientPaymentsTable from '@/components/tables/ManagedClientPaymentsTable.vue'

export default {
  components: {
    breadcrumb: BreadCrumb,
    'payments-table': ManagedClientPaymentsTable,
  },
  data() {
    return {
      showAddPaymentDialog: false,
      icons: {
        mdiCash,
      },
      breadcrumbs: [
        {
          text: 'Dashboard',
          disabled: false,
          to: { name: 'dashboard' },
        },
        {
          text: 'Managed Clients',
          disabled: false,
          to: { name: 'managed-clients' },
        },
        {
          text: 'Payments',
          disabled: true,
          to: { name: 'payments' },
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['selectedStation']),
    transactionUrl() {
      return 'managed-client-payments?'
    },
  },
}
</script>
